import { generateId } from '@freelancer/datastore/testing/helpers';
import type { Videochat } from './videochats.model';

export interface GenerateVideochatOptions {
  readonly id?: number;
  readonly callerUserId: number;
  readonly receiverUserId: number;
  readonly threadId: number;
  readonly endReason?: string;
  readonly startTime: number;
  readonly endTime?: number;
}

export function generateVideochatObject({
  id = generateId(),
  callerUserId,
  receiverUserId,
  threadId,
  endReason,
  startTime,
  endTime,
}: GenerateVideochatOptions): Videochat {
  return {
    id,
    callerUserId,
    receiverUserId,
    threadId,
    endReason,
    startTime,
    endTime,
  };
}
